import React from "react";
import CustomSlider from "../section/CustomSlider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function SignuUpTeachers() {
    const { t } = useTranslation();
    return (
        <section className="relative h-[100vh]">
            <div className="container h-full flex justify-between items-center">
                <div className="w-[45%] flex flex-col gap-[40px]">
                    <div>
                        <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                    </div>
                    <div className="flex flex-col text-[#09778E] font-bold text-[30px]">
                        <div>{t("Welcome to Academicx")}</div>
                        <div>{t("Learning Platform as a Teacher")}</div>
                    </div>
                    <div>
                        <CustomSlider />
                    </div>
                </div>
                <div className="w-[5%]">
                    <img className="h-[650px]" src={require("../../assets/icons/rigister-line.svg").default} alt="" />
                </div>
                <div className="w-[45%] flex flex-col justify-between gap-[50px]">
                    <div className="flex items-center text-center flex-col gap-[8px] justify-center">
                        <div className="flex flex-col text-[#09778E] font-bold text-[30px] capitalize">{t("fill in the fields to create your account")}</div>
                        <div className="flex items-center gap-[12px]">
                            <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                            <div className="text-[#5D5A6F] flex items-center gap-[5px]">
                                {t("Do you have an account ?")}<Link to={"/login"} className="text-[#09758b]">{t("Login Now")}</Link>
                            </div>
                            <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                        </div>
                    </div>
                    <form>
                        <div className="flex flex-col gap-[8px]">
                            <div className="flex items-center gap-[25px]">
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">{t("First Name")}</label>
                                    <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your First Name")} />
                                </div>
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">{t("Last Name")}</label>
                                    <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Last Name")} />
                                </div>
                            </div>
                            <div className="flex items-center gap-[25px]">
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">{t("Phone Number")}</label>
                                    <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Phone Number")} />
                                </div>
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">{t("Your Email")}</label>
                                    <input type="email" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Email")} />
                                </div>
                            </div>
                            <div className="flex items-center gap-[25px]">
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">(t{"Gender"})</label>
                                    <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none">
                                        <option value="">{t("Select Your Gender")}</option>
                                        <option value="male">{t("Male")}</option>
                                        <option value="female">{t("Female")}</option>
                                        <option value="other">{t("Other")}</option>
                                    </select>
                                </div>
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">(t{"Select Age Group Taught"})</label>
                                    <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none">
                                        <option value="">{t("Select Age Group Taught")}</option>
                                        <option value="child">(t{"Child"})</option>
                                        <option value="teen">(t{"Teen"})</option>
                                        <option value="adult">(t{"Adult"})</option>
                                        <option value="senior">{t("Senior")}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex items-center gap-[25px]">
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">(t{"Number of Years of Experience"})</label>
                                    <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Number of Years of Experience")} />
                                </div>
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">{t("Select Subject")}</label>
                                    <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none">
                                        <option value="">{t("Select Subject")}</option>
                                        <option value="child">Child</option>
                                        <option value="teen">Teen</option>
                                        <option value="adult">Adult</option>
                                        <option value="senior">Senior</option>
                                    </select>
                                </div>
                            </div>
                            <div className="flex items-center gap-[25px]">
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">Password</label>
                                    <input type="password" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder="Your Password" />
                                </div>
                                <div className="w-[50%] flex flex-col gap-[5px]">
                                    <label className="text-[#09778E] font-bold">Confirm Password</label>
                                    <input type="password" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder="Confirm Password" />
                                </div>
                            </div>
                            <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">Sign Up</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}